import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import Logo from '../../assets/images/carepayLogo.png';
import { useNavigate } from 'react-router-dom';
import { login } from '../../api/action-creator';
import './login.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({
    merchantCode: '',
    password: '',
  });

  const handleChangePayload = (e) => {
    setError('');
    setPayload({ ...payload, [e.target.name]: e.target.value });
  };

  const handleLogin = () => {
    if (payload.merchantCode.length < 3 || payload.password.length < 1) {
      setError('Please enter a valid merchant code and password.');
      return;
    }

    setLoading(true);
    setError('');

    login(
      payload,
      (callback) => {
        setLoading(false);
        if (callback.status === 200) {
          localStorage.setItem('doctorId', callback?.data?.doctorId);
          localStorage.setItem('merchantCode', payload?.merchantCode ?? '');
          localStorage.setItem('password', payload?.password ?? '');
          navigate('/dashboard');
        } else {
          setError(callback?.data ?? 'User not found');
        }
      },
      () => {
        setLoading(false);
        setError('Something went wrong, please try again.');
      }
    );
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') handleLogin();
  };

  return (
    <div className="login-page">
      <section className="login-hero" aria-hidden="true">
        <h1>
          Grow your revenue,
          <br />
          with CarePay&apos;s
          <br />
          instant treatment
          <br />
          financing.
        </h1>
      </section>

      <section className="login-panel">
        <div className="login-form-wrap">
          <div className="login-brand">
            <img src={Logo} alt="CarePay" className="login-logo" />
            <p className="login-mobile-tagline">
              Instant treatment financing for your clinic
            </p>
          </div>

          <div className="login-form-card">
            <h3>Sign in</h3>
            <p className="login-subtitle">Access your CarePay partner dashboard</p>

            {error && <p className="login-error">{error}</p>}

            <div className="login-field">
              <label htmlFor="merchantCode">Merchant code</label>
              <input
                id="merchantCode"
                type="text"
                name="merchantCode"
                value={payload.merchantCode}
                onChange={handleChangePayload}
                onKeyDown={handleKeyDown}
                autoComplete="username"
                placeholder="Enter merchant code"
                inputMode="text"
              />
            </div>

            <div className="login-field">
              <label htmlFor="password">Password</label>
              <div className="login-password-wrap">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={payload.password}
                  onChange={handleChangePayload}
                  onKeyDown={handleKeyDown}
                  autoComplete="current-password"
                  placeholder="Enter password"
                />
                <button
                  type="button"
                  className="login-toggle-password"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <div className="login-actions">
              <button
                type="button"
                className="login-submit"
                onClick={handleLogin}
                disabled={loading}
              >
                {loading ? 'Signing in…' : 'Sign in'}
              </button>
            </div>
          </div>

          <p className="login-footer-note">Need help? Contact your CarePay partner manager</p>
        </div>
      </section>
    </div>
  );
};

export default LoginPage;
